import { render } from "./VistaProjecte.vue?vue&type=template&id=5fa9e8e4"
import script from "./VistaProjecte.vue?vue&type=script&lang=js"
export * from "./VistaProjecte.vue?vue&type=script&lang=js"

import "./VistaProjecte.vue?vue&type=style&index=0&id=5fa9e8e4&lang=css"

import exportComponent from "/opt/app-root/src/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__